import { ReportDashboardMetricOptions } from './metrics.types';
import { ReportDashboardComponentViewData } from './report-component.types';
import { ReportResults } from './report-results.types';

export enum ReportLibraryComponentCategory {
  All = 'All',
  Candidates = 'candidates',
  Jobs = 'jobs',
  Disqualifications = 'disqualifications',
  TeamMembers = 'team_members',
  TalentPools = 'talent_pools',
  Evaluations = 'evaluations',
  Events = 'events',
  Hires = 'hires',
  Pipelines = 'pipelines',
  CareerSite = 'career_site',
  Requisitions = 'requisitions',
  Campaigns = 'campaigns',
  Diversity = 'diversity',
  Employees = 'employees',
  Payroll = 'payroll',
  Tenure = 'tenure',
}

export type ReportDashboardLibraryComponent = ReportDashboardComponentViewData & {
  isNew: boolean;
  categories: ReportLibraryComponentCategory[];
  libraryContent: string;
  libraryId: string;
  sampleData: ReportResults['results'];
  localId: string;
};

export interface ReportDashboardLibraryApiResponse {
  componentTemplates: ReportDashboardLibraryComponent[];
  metrics: ReportDashboardMetricOptions[];
}
